import React from "react";
import Header from "../../components/Header";
import AboutUs from "./AboutUs";
import Services from "./Services";
import Portfolio from "./Portfolio";
// import Team from "./Team";
import Footer from "../Footer/Footer";
// import SmallFooter from "../Footer/SmallFooter";

const Home = () => {
    //console.log("RELOAD");
    return (
        <div style={{}}>  
            <Header className={null} />
            <main id="main">
                <AboutUs />
                <Services />            
                <Portfolio />
                <Footer />
            </main>
            {/* <Team /> */}
        </div>
    )
}

export default Home;